import axios from "axios";
import {eventBus} from "@/eventBus";

const Axios = axios.create({
  // baseURL: 'http://localhost:5010'
  baseURL: 'http://affystat.durban:5010'
});

Axios.interceptors.request.use(function (config) {
  // Do something before request is sent

  if (config.url === 'login') {
    return config;
  }

  const token = localStorage.getItem('token')
  const userId = localStorage.getItem('userId')
  if (!token || !userId) {
    throw new Error('Нет ключа авторизации')
  }

  config.headers['authorization'] = token;
  config.headers['id'] = userId;

  return config;
}, function (error) {
  const errorMsg = error.message || ''
  eventBus.$emit('apiError', errorMsg)
  return Promise.reject(error);
});

Axios.interceptors.response.use(function (response) {
    return response;
  },
  function (error) {
    const errorMsg = error.response?.data?.message || ''
    eventBus.$emit('apiError', errorMsg)
    if (errorMsg === 'Невалидный ключ') {
      eventBus.$emit('logout')
    }
    return Promise.reject(error);
  });

export const ApiService = {
  login(data) {
    return Axios.post('login', data)
      .then(res => res.data)
  },
  getUsers() {
    return Axios.get('users')
      .then(res => res.data)
  },

  getTotalDetail() {
    return Axios.get('total-detail').then(res => res.data)
  },
  getTotal() {
    return Axios.get('total').then(res => res.data)
  },
  search(data) {
    return Axios.post('search', {data}).then(res => res.data)
  },
  updateUser(data) {
    return Axios.post('update-user', {data})
  },
  deleteUser(id) {
    return Axios.post('delete-user', {id})
  }
}
